// extracted by mini-css-extract-plugin
module.exports = {"list":"AdvantagesList_list___XG9y"};